"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "integrations-body"
  }, [_c('h2', {
    staticClass: "integrations-title"
  }, [_vm._v("INTEGRACIONES Y REDES SOCIALES")]), _c('p', {
    staticClass: "integrations-subtitle"
  }, [_vm._v("Conecta tus plataformas favoritas para sincronizar notificaciones, calendarios y contenido exclusivo.")]), _c('div', {
    staticClass: "integrations-list"
  }, _vm._l(_vm.integrations, function (item, idx) {
    return _c('div', {
      key: idx,
      staticClass: "integration-card",
      class: {
        'is-connected': item.connected
      }
    }, [_c('div', {
      staticClass: "integration-icon-box",
      style: {
        color: item.color
      }
    }, [_c('i', {
      class: ['fa', item.icon],
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('div', {
      staticClass: "integration-info"
    }, [_c('h4', {
      staticClass: "integration-name"
    }, [_vm._v(_vm._s(item.name))]), _c('p', {
      staticClass: "integration-desc"
    }, [_vm._v(_vm._s(item.description))]), item.connected ? _c('span', {
      staticClass: "status-badge connected"
    }, [_vm._v("CONECTADO")]) : _c('span', {
      staticClass: "status-badge disconnected"
    }, [_vm._v("DESCONECTADO")])]), _c('div', {
      staticClass: "integration-action"
    }, [item.name === 'Telegram' && !item.connected ? _c('div', {
      attrs: {
        "id": "telegram-login-container"
      }
    }, [_c('button', {
      staticClass: "connect-btn",
      on: {
        "click": _vm.loadTelegramWidget
      }
    }, [_c('i', {
      staticClass: "fa fa-paper-plane"
    }), _vm._v(" ACTIVAR BOT ")])]) : !item.connected ? _c('button', {
      staticClass: "connect-btn",
      on: {
        "click": function ($event) {
          return _vm.handleConnect(item);
        }
      }
    }, [_vm._v(" CONECTAR ")]) : _c('button', {
      staticClass: "disconnect-btn",
      on: {
        "click": function ($event) {
          return _vm.toggleIntegration(item);
        }
      }
    }, [_vm._v(" DESCONECTAR ")])])]);
  }), 0)]);
};
var staticRenderFns = exports.staticRenderFns = [];